import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useLanguage } from '../i18n/LanguageProvider';

/**
 * Reads the `?payment=success|failed` query parameter set by the payment
 * vendor's return redirect and shows a toast. The actual subscription
 * activation happens asynchronously via the HMAC-signed payment webhook
 * at /api/payments/webhook — this component is purely UX feedback on
 * the redirect back.
 *
 * Mounted once in App.tsx so every return URL is handled regardless of
 * which app's page the vendor redirects to.
 */
export const PaymentReturnToast = () => {
  const { messages } = useLanguage();
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const payment = params.get('payment');
    if (payment !== 'success' && payment !== 'failed') return;

    if (payment === 'success') {
      toast.success(messages.billing.paymentSuccess);
    } else {
      toast.error(messages.billing.paymentError);
    }

    // Clean up the query params so the toast doesn't re-fire on nav.
    params.delete('payment');
    params.delete('at');
    const next = params.toString();
    navigate(`${pathname}${next ? `?${next}` : ''}`, { replace: true });
  }, [search, pathname, navigate, messages]);

  return null;
};
